<template>
  <div >
    <!-- 导航栏 -->
    <Header :title="titleName" link="projectorInfo" ></Header>
    <div class="appContent">
    <div class="view-info">
       <van-cell :title="$t('T_ROOM_SIZE')" :value="roomWData+'x'+roomHData+'x'+roomDData+unitLabel|filterFeet"  />
       <van-cell :title="$t('T_SCREEN_SIZE')" :value="scrnWData+'x'+scrnHData+unitLabel|filterFeet"  />
       <div class="view-settings"><van-button  plain @click="settingAction">{{$t("T_MORE_SETTINGS")}}</van-button></div>
    </div>
    <div class="twoD-view" v-if="!isUSTWall && !isSimple">
      <div class="view-cv" >
        <div class="view-title">{{$t('T_SIDE_VIEW')}}</div>
        <div class="view-content">
          <Sideview ref='sideView' :slot="$store.state.view[1].value"></Sideview>
        </div>
        <div class="angle-msg-container">
          <div class="angle-msg" v-show="isVAngleTypeOneOut">{{$t('T_CHANGE_SETTING_MSG')}}</div>
          <div class="angle-msg" v-show="isVAngleTypeTwoOut">{{$t('T_CAUSE_MALFUNCTION_OR_ACCIDENT_MSG')}}</div>
        </div>

      </div>
      <div class="space"></div>
      <div class="view-cv">
        <div class="view-title">{{$t('T_FRONT_VIEW')}}</div>
        <div class="view-content">
          <Frontview ref='frontView' :slot="$store.state.view[2].value"></Frontview>
        </div>
      </div>
      <div class="space"></div>
      <div class="view-cv">
        <div class="view-title">{{$t('T_TOP_VIEW')}}</div>
        <div class="view-content">
          <Topview ref='topView' :slot="$store.state.view[3].value"></Topview>
        </div>
      </div>
    </div>
    <div class="space"></div>
    <div class="view-cv" v-show="!isUSTWall && !isSimple">
      <div class="view-title">3D {{$t("T_VIEW")}}</div>
      <div class="view-content">
        <ThreeDview ref='threeDview' :slot="$store.state.view[0].value"></ThreeDview>
      </div>
    </div>
    <div class="ust-view" v-if="isUSTWall">
      <USTSideView :pjImgType='pjImgType'></USTSideView>
    </div>
    <div class="simple-view" v-if="isSimple">
      <SimpleView></SimpleView>
    </div>
    <div class="space"></div>
    <div class="simple_condition" v-if="isSimple">
      <projectorCondition></projectorCondition>
    </div>
    <div class="space"></div>
    <div class="simulation-result">
      <resultInformation :showConditionFlag="showConditionFlag"></resultInformation>
    </div>
    <div class="space"></div>
    <div class="view-Brightness">
      <!-- Brightness & Contrast guide -->
      <resultBrightnessGuide></resultBrightnessGuide>
    </div>
    </div>
    <div class="popup">
      <van-popup v-model="showConditionFlag" position="right" :style="{ height: '100%', width: '100%'}">
        <projectorCondition :showConditionFlag="showConditionFlag" @close="closeAction"/>
      </van-popup>
    </div>
  </div>
</template>

<script>
import Header from '@/components/header'
import Sideview from '@/components/graph/sideView'
import Frontview from '@/components/graph/frontView'
import Topview from '@/components/graph/topView'
import ThreeDview from '@/components/graph/threeDView'
import projectorCondition from '@/views/ProjectorCondition'
import resultInformation from '@/views/result/resultInformation'
import resultBrightnessGuide from '@/views/result/resultBrightnessGuide'
import USTSideView from '@/views/UST/USTSideView'
import SimpleView from '@/views/Simple/SimpleView'
import { mapState, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'projectorView',

  data () {
    return {
      showConditionFlag: false,
      roomWData: '',
      roomHData: '',
      roomDData: '',
      scrnWData: '',
      scrnHData: '',
      titleName: this.$store.state.selectedModelData.name,
      LatviaCode: ['H919', 'H921', 'H923'],
      isLatvia: false,
      isVAngleTypeOneOut: false,
      isVAngleTypeTwoOut: false
    }
  },
  filters: {
    filterFeet (value) {
      return value === 'inch' ? 'ft' : value
    }
  },
  props: {
    tableTitle: String
  },
  methods: {
    settingAction () {
      this.showConditionFlag = true
      history.pushState(null, null, '#')
    },
    initData () {
      this.roomWData = this.$commonJs.changeUnit(this.houseInfo.roomW, this.graph.unit, false, true)
      this.roomHData = this.$commonJs.changeUnit(this.houseInfo.roomH, this.graph.unit, false, true)
      this.roomDData = this.$commonJs.changeUnit(this.houseInfo.roomD, this.graph.unit, false, true)
      this.scrnWData = this.$commonJs.changeUnit(this.graph.scrnW, this.graph.unit)
      this.scrnHData = this.$commonJs.changeUnit(this.graph.scrnH, this.graph.unit)
      if (this.drawData) {
        let data = this.drawData[0].reduce((data1, data2) => {
          return data1.z > data2.z ? data1 : data2
        })
        this.SET_FLOOR2BOTTOM(this.roomH - data.z)
        this.floor2bottomData = this.$commonJs.changeUnit(this.roomH - data.z, this.unit)
      }
    },

    closeAction () {
      this.showConditionFlag = false
    },
    setSpecificInfo (data) {
      let defaultRatio = data.lcd.aspectRatio
      let defaultDistInfo = data.lcd.distInfo.find(
        item => item.ratio === defaultRatio
      )
      this.F_S2D(defaultDistInfo.size2dist)
      this.F_D2S(defaultDistInfo.dist2size)
      this.F_VOFFSET(defaultDistInfo.screenSizeToVOffset)

      this.VLENSSHIFT(data.lcd.lensShiftRange.v)
      this.SET_TEMVLENSSHIFT(data.lcd.lensShiftRange.v)
      this.HLENSSHIFT(data.lcd.lensShiftRange.h)
      this.VHLENSSHIFT(data.lcd.lensShiftRange.hv)
      this.ASPECTRATIO(data.lcd.aspectRatio)
      // 为超短焦设置默认vlens shift
      if (this.selectedModelData.type === 1 && data.lcd.lensShiftRange.v.min === 0 && data.lcd.lensShiftRange.v.max === 0) {
        let initSize = this.$commonViewJs.getScreenXYByScreenSize(defaultDistInfo.screenSize.w.min, defaultRatio)
        let v1b = defaultDistInfo.screenSize.w.min * defaultDistInfo.v1b.w.a + defaultDistInfo.v1b.w.b
        let res = (initSize.calY / 2 + v1b - data.mu) / initSize.calY
        this.SET_VLENSSHIFT(res)
        let vals = {}
        if (this.position === 1 || this.position === 2) {
          this.SET_VLENSSHIFT(res * 100 * -1)
        } else {
          this.SET_VLENSSHIFT(res * 100)
        }
        vals.max = res
        vals.min = res
        data.lcd.lensShiftRange.v = vals
        this.VLENSSHIFT(vals)
        this.SET_TEMVLENSSHIFT(vals)
      } else if (this.$commonViewJs.isLongLensExistsLens()) {
        let initSize = this.$commonViewJs.getScreenXYByScreenSize(defaultDistInfo.screenSize.w.min, defaultRatio)
        let res = (defaultDistInfo.wv.wv2 * defaultDistInfo.screenSize.w.min - initSize.calY / 2) / initSize.calY
        this.SET_VLENSSHIFT(res)
        let va = {}
        va.max = res
        va.min = res
        this.VLENSSHIFT(va)
        this.SET_TEMVLENSSHIFT(va)
      }
    },
    onBrowserBack () {
      let hash = window.location.hash
      if (this.showConditionFlag) {
        this.showConditionFlag = false
      } else {
        if (hash === '#/projectorView') {
          this.$router.push({ name: 'projectorInfo', params: { modelChange: false } })
        }
      }
    },
    setUSTStatus () {
      if (this.selectedModelData.category === 4 && this.position === 2) {
        this.SET_ISUSTWALL(true)
        this.SET_ISSIMPLE(false)
      } else {
        this.SET_ISUSTWALL(false)
      }
      let val = this.houseInfo.roomH > 180 ? this.houseInfo.roomH - 180 : 0
      this.PJZ(val)
    },
    ...mapMutations([
      'SELECTEDLENSDATA',
      'F_S2D',
      'F_D2S',
      'F_VOFFSET',
      'VLENSSHIFT',
      'HLENSSHIFT',
      'VHLENSSHIFT',
      'ASPECTRATIO',
      'SET_TEMVLENSSHIFT',
      'SET_ISUSTWALL',
      'SET_ISSIMPLE',
      'PJZ',
      'SET_ISLATVIA',
      'SET_APPLICATION',
      'SET_OFFSET',
      'SET_FLOOR2BOTTOM'
    ])

  },
  created () {
    this.initData()
    if (this.selectedLensData === null) {
      let lensInfo = this.$commonJs.findLensInfo(this.$store.state.selectedModelData)
      this.SELECTEDLENSDATA(lensInfo.selectedLensInfo)
      this.setSpecificInfo(lensInfo.selectedLensInfo)
    }
    this.setUSTStatus()
  },
  mounted () {
    if (window.history && window.history.pushState) {
      window.addEventListener('popstate', this.onBrowserBack, false)
    }
    this.isLatvia = this.LatviaCode.indexOf(this.selectedModelData.code) !== -1
    this.SET_ISLATVIA(this.isLatvia)
    if (this.isUSTWall) {
      this.SET_APPLICATION('1')
      this.SET_OFFSET(0)
    } else {
      this.SET_APPLICATION('0')
    }
  },
  destroyed () {
    if (window.history && window.history.pushState) {
      window.removeEventListener('popstate', this.onBrowserBack, false)
    }
  },
  watch: {
    roomW (newValue, oldValue) {
      this.roomWData = this.$commonJs.changeUnit(newValue, this.graph.unit, false, true)
    },

    roomH (newValue, oldValue) {
      this.roomHData = this.$commonJs.changeUnit(newValue, this.graph.unit, false, true)
    },

    roomD (newValue, oldValue) {
      this.roomDData = this.$commonJs.changeUnit(newValue, this.graph.unit, false, true)
    },
    scrnW (newValue, oldValue) {
      this.scrnWData = this.$commonJs.changeUnit(newValue, this.graph.unit)
    },

    scrnH (newValue, oldValue) {
      this.scrnHData = this.$commonJs.changeUnit(newValue, this.graph.unit)
    },
    unit (newValue, oldValue) {
      this.roomWData = this.$commonJs.changeUnit(this.roomW, newValue, false, true)
      this.roomHData = this.$commonJs.changeUnit(this.roomH, newValue, false, true)
      this.roomDData = this.$commonJs.changeUnit(this.roomD, newValue, false, true)
      this.scrnWData = this.$commonJs.changeUnit(this.scrnW, newValue)
      this.scrnHData = this.$commonJs.changeUnit(this.scrnH, newValue)
    },
    drawData (newValue, oldValue) {
      if (newValue) {
        let data = newValue[0].reduce((data1, data2) => {
          return data1.z > data2.z ? data1 : data2
        })
        this.SET_FLOOR2BOTTOM(this.roomH - data.z)
        this.floor2bottomData = this.$commonJs.changeUnit(this.roomH - data.z, this.unit)
      }
    }
  },
  computed: {
    ...mapState([
      'houseInfo', 'graph', 'selectedModelData', 'selectedLensData', 'position', 'isUSTWall', 'drawData', 'language', 'isSimple'
    ]),
    ...mapGetters([
      'unitLabel'
    ]),
    roomW () {
      return this.houseInfo.roomW
    },

    roomH () {
      return this.houseInfo.roomH
    },

    roomD () {
      return this.houseInfo.roomD
    },
    scrnW () {
      return this.graph.scrnW
    },

    scrnH () {
      return this.graph.scrnH
    },
    unit () {
      return this.graph.unit
    },
    pjImgType () {
      return this.isLatvia ? 'P2' : 'P1'
    }
  },
  components: {
    Sideview,
    Header,
    projectorCondition,
    resultInformation,
    resultBrightnessGuide,
    Frontview,
    Topview,
    ThreeDview,
    USTSideView,
    SimpleView
  }
}
</script>

<style scoped>
.angle-msg-container{
  height: 0.5rem;
}
.angle-msg {
  border: 1px solid;
  background-color: #f7baf7;
  font-size: 0.32rem;
  width: fit-content;
  transform: translateX(-50%);
  left: 50%;
  position: relative;
}
</style>
